export default function Works(props) {

  return (
      <div className='works' id={props.index}>
        <div className='wimgcntr'>
          <img src={props.image1} alt='workname' />
        </div>
        <div className='wdetails'>
          <h1>{props.name}</h1>
          <p>
            {props.desc}
          </p>
            <p><strong>Languages Used:- </strong>{props.lang}</p>
            <a href={`//${props.url}`} className="linkdin" target="_blank" rel="noopener noreferrer">
              <button>Visit Website</button>
            </a>
        </div>
      </div>
  )
}
